import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { validateCpf, validateCnpj } from './utils/documentValidators'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const DocumentValidator = () => {
  useDocumentMeta({
    title: 'Validador de CPF e CNPJ | jarder.dev',
    description:
      'Digite um CPF ou CNPJ e confira na hora se os dígitos ' +
      'verificadores batem. Grátis, direto no navegador.',
  })

  const [value, setValue] = useState('')

  const result = useMemo(() => {
    const digits = value.replace(/\D/g, '')
    if (digits.length === 0) return null
    if (digits.length === 11) {
      return { type: 'CPF', valid: validateCpf(value) }
    }
    if (digits.length === 14) {
      return { type: 'CNPJ', valid: validateCnpj(value) }
    }
    return { type: null, valid: false }
  }, [value])

  const handleBlur = () => {
    if (result) trackEvent('tool_generate', { tool: 'document_validator', type: result.type })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Validador de CPF e CNPJ</h1>
      <p className="tool-disclaimer">
        Verifica apenas se os dígitos verificadores são matematicamente
        válidos, não confirma se o documento existe ou está ativo.
      </p>

      <div className="tool-field">
        <label htmlFor="document">CPF ou CNPJ</label>
        <input
          id="document"
          type="text"
          placeholder="000.000.000-00 ou 00.000.000/0000-00"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={handleBlur}
        />
      </div>

      {result && (
        <div className="tool-result-card">
          <span className="tool-result-label">
            {result.type || 'Quantidade de dígitos inválida'}
          </span>
          <span
            className="tool-result-value"
            style={{ color: result.valid ? 'var(--success)' : 'var(--danger)' }}
          >
            {result.type
              ? result.valid
                ? '✓ Válido'
                : '✗ Inválido'
              : 'Digite 11 dígitos (CPF) ou 14 (CNPJ)'}
          </span>
        </div>
      )}

      <div className="tool-info-section">
        <h2>O que a validação verifica</h2>
        <p>
          CPF e CNPJ têm dois últimos dígitos calculados a partir dos
          demais, por uma fórmula de módulo 11. Esta ferramenta refaz
          esse cálculo e confere se os dígitos batem  útil para pegar
          erros de digitação antes de enviar um formulário. Isso{' '}
          <strong>não confirma</strong> que o documento foi realmente
          emitido pela Receita Federal ou que está ativo  para isso é
          preciso consultar a base oficial da Receita.
        </p>
      </div>
    </div>
  )
}

export default DocumentValidator
